'use client';

import Button from 'components/controls/buttons/button';
import styles from './application-link.module.scss';

interface ApplicationLinkProps {
	applicationUrl: string;
	applicationCta: string;
	applicationIsOpen: boolean;
	applicationAvailabilityMessage?: string;
}

const ApplicationLink = ({
	applicationUrl,
	applicationCta,
	applicationIsOpen,
	applicationAvailabilityMessage,
}: ApplicationLinkProps) => {
	return (
		<>
			<Button
				appearance="primary"
				disabled={!applicationIsOpen}
				onClick={() => {
					if (applicationIsOpen) {
						window.location.href = applicationUrl;
					}
				}}
				className={styles.buttonWrapper}
			>
				{applicationCta}
			</Button>
			{applicationAvailabilityMessage && (
				<p
					className={`${styles.availabilityMessage} ${applicationIsOpen ? styles.availabilityMessageOpen : styles.availabilityMessageClosed}`}
				>
					{applicationAvailabilityMessage}
				</p>
			)}
		</>
	);
};

export default ApplicationLink;
export type { ApplicationLinkProps };
